// NATIVE 
import React, { useEffect, useState } from 'react';


// INSTALLED 
import Box from '@mui/material/Box';
import { Form, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, CardActionArea, CardMedia, Divider, Grid } from '@mui/material';



// CUSTOM 
import { saveCompany } from '../../store/company';
import { uploadImgStore } from '../../store/uploaders';
import { IDatosBasicos } from '../../commons/interfaces';
import { SnackAlert } from '../../components/SnackAlert';
import { LinearProgressWithLabel } from '../../components';
import InputField from '../../components/formFields/InputField';
import { MessagesDrawerRight } from '../../components/MessagesDrawerRight';
import AutocompleteField from '../../components/formFields/autocompleteField';
import { UploadButtonField } from '../../components/formFields/uploadButtonField';
import AutocompleteFieldCountry from '../../components/formFields/autocompleteFieldCountry';
import AutocompleteFieldDepartament from '../../components/formFields/AutocompleteFieldDepartament';
import createSucursalFormModel from '../../components/sucursal/formModels/createSucursalFormModel';
import { getSucursalDataSelects } from '../../store/sucursal';
import { ModalSessionExpired } from '../generics/ModalSessionExpired';
import { timeToClosedToast } from '../../commons';
import MultipleSnackbars from '../MultipleSnackbars';
import { closeSessionGlobal } from '../../commons/utils';








/**
 * SucursalEmpresa component is responsible for rendering a form to create or update a company branch (sucursal).
 * It utilizes Redux for state management and Formik for form handling.
 * 
 * @param {any} props - The properties passed to the component.
 * 
 * @returns {JSX.Element} The rendered component.
 * 
 * @component
 * 
 * @example
 * return (
 *   <SucursalEmpresa />
 * )
 * 
 * @remarks
 * This component includes various form fields such as name, address, country, department, municipality, workplace, landline, cell phone, ARL, associated bank, type of bank account, and account number.
 * It also handles file uploads for the branch logo and displays a preview of the uploaded image.
 * 
 * @requires useDispatch - Redux hook to dispatch actions.
 * @requires useSelector - Redux hook to access the state.
 * @requires useFormikContext - Formik hook to access form context.
 * @requires useState - React hook to manage local state.
 * @requires useEffect - React hook to handle side effects.
 * 
 * @todo
 * - Improve error handling and validation.
 * - Add more detailed comments and documentation for each function and state variable.
 */
export const SucursalEmpresa = (props:any) => {


  //  USE DISPATCH 
  const dispatch = useDispatch();

  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]); 
  const [msgSnack, setMsgSnack] = React.useState({
        msg: '',
        status: 'success'
  });
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  // REDUX
  const { workplace_list_select }:any  = useSelector( (state:any) => state.workplace );

  const { country_list_select }:any  = useSelector( (state:any) => state.country );
  const { departaments_list_select }:any  = useSelector( (state:any) => state.departaments );
  const { municipaly_list_select }:any  = useSelector( (state:any) => state.municipalies );

  const { arl_list_select }:any   = useSelector( (state:any) => state.arl );


  const  {  family_compensation_list_select }:any  = useSelector( (state:any) => state.cajaCompensacion );


  const { associated_bank_select }:any = useSelector( (state:any) => state.associatedbank );
  const { type_account_bank_list_select }:any = useSelector( (state:any) => state.typeaccountbank );



  // DATA FORM MODELS
  const { formId, formField } = createSucursalFormModel;



  // USE STATE 
  const [data, setMsgErrors] = useState([]);
  const [alert_snack, setAlertSnack] = useState(false);
  const [textAlertSnack, setTextAlertSnack] = useState('');
  const [severity, setSeverity] = useState('success');
  
  const [percentaje_c_Company, setPercentajeCCompany] = useState(0);
  const [percentage_upload_sucursal, setPercentageUploadSucursal] = useState(0);
  const [departaments,   setDepartaments]  = useState([]);
  const [activity_economic, setActivityEconomic] = useState([]);
  const [municipalies,   setMunicipalies]  = useState([]);
  const [file_post_name, setSucursalFileName] = useState('');
  const [file_logo_post, setFileSucursal] = useState(null);
  const [preview_sucursal, setPreviewSucursal] = useState('');


//   FORM FIELDS 
  const { 
      sucursal_name,
      sucursal_address,
      country,
      departament,
      municipaly,
      workplace,
      family_fund_compensation,
      landline,
      cell_phone,
      arl,
      associated_bank,
      type_account_bank,
      account_number,
      logo_sucursal,
    
  } = formField;

  const formikProps:any = useFormikContext();
  




  
   
    useEffect(() => {
        sucursalDataSelects()
    }, []);
    

    const sucursalDataSelects = async() => {
        await  dispatch( getSucursalDataSelects() );
    }
   


  const uploadFileLogoSucursal = async({ target }:any) => {
 
    
      const { name } = target.files[0];
      setSucursalFileName(name);
      setFileSucursal(target.files[0]);

      const objectURL = URL.createObjectURL(target.files[0]);
      setPreviewSucursal(objectURL);

      formikProps.setFieldValue('logo_sucursal', target.files[0]);
      const response = await dispatch( uploadImgStore( 'image-sucursal', target.files[0], setPercentageUploadSucursal) );
     

        if (!response.ok) {


            formikProps.setFieldValue('logo_sucursal', null);
            setSeverity('error')
            setTextAlertSnack(response.errors[0]);
            setAlertSnack(true);
            return false;
        }

      if (response.ok) {
          formikProps.setFieldValue('logo_sucursal_name_saved_file', response.data.imgName);
      }
  
      
  }




return (
  <Box sx={{ width: '100%' }}>
   
      <ModalSessionExpired  open={modalSessionExpired}  />
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
      
      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={textAlertSnack} severity={severity}/>
      

        <Card style={{ marginTop: 50,  padding: 20}}>
              <Form id={formId}>


            <Grid container spacing={2} alignItems="flex-start" sx={{ padding: 2 }}>
  
  {/* Inputs principales */}
  <Grid size={{ xs: 9 }}>
    <Grid container spacing={2}>
      {/* Fila 1 */}
      <Grid size={{ xs: 4 }}>
        <InputField name={sucursal_name.name} label={sucursal_name.label} variant="outlined" autoComplete="off" fullWidth />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <InputField name={sucursal_address.name} label={sucursal_address.label} variant="outlined" autoComplete="off" fullWidth />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <AutocompleteField options={workplace_list_select} name={workplace.name} label={workplace.label} />
      </Grid>

      {/* Fila 2 */}
      <Grid size={{ xs: 4 }}>
        <AutocompleteFieldCountry options={country_list_select} name={country.name} label={country.label} element={country.name} />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <AutocompleteFieldDepartament options={departaments_list_select} name={departament.name} label={departament.label} element={departament.name} />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <AutocompleteField options={municipaly_list_select} name={municipaly.name} label={municipaly.label} element={municipaly.name} />
      </Grid>

      {/* Fila 3 */}
      <Grid size={{ xs: 4 }}>
        <AutocompleteField options={family_compensation_list_select} name={family_fund_compensation.name} label={family_fund_compensation.label} element={family_fund_compensation.name} />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <InputField name={landline.name} label={landline.label} variant="outlined" autoComplete="off" fullWidth />
      </Grid>
      <Grid size={{ xs: 4 }}>
        <InputField name={cell_phone.name} label={cell_phone.label} variant="outlined" autoComplete="off" fullWidth />
      </Grid>

      <Grid size={{ xs: 3 }}>
                    <AutocompleteField options={arl_list_select} name={arl.name} label={arl.label} element={arl.name} />
                </Grid>
                <Grid size={{ xs: 3 }}>
                    <AutocompleteField options={associated_bank_select} name={associated_bank.name} label={associated_bank.label} element={associated_bank.name} />
                </Grid>
                <Grid size={{ xs: 3 }}>
                    <AutocompleteField options={type_account_bank_list_select} name={type_account_bank.name} label={type_account_bank.label} element={type_account_bank.name} />
                </Grid>
                <Grid size={{ xs: 3 }}>
                    <InputField name={account_number.name} label={account_number.label} variant="outlined" autoComplete="off" fullWidth />
                </Grid>
    </Grid>
  </Grid>

        {/* Logo */}
        <Grid size={{ xs: 3 }}>
            <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
                <Button>Sube Tu Logo Post Comercial</Button>
                <Divider sx={{ my: 1 }} />
                <UploadButtonField
                onChange={uploadFileLogoSucursal}
                accept={'image/*'}
                name={logo_sucursal.name}
                label={logo_sucursal.label}
                text={'Subir Archivo'}
                />

                {formikProps.values.logo_sucursal && (
                <>
                    <Card sx={{ maxWidth: '100%', mt: 2 }}>
                    <CardActionArea>
                        <CardMedia
                        component="img"
                        height="140"
                        sx={{ objectFit: 'contain' }}
                        image={preview_sucursal}
                        alt="Logo sucursal"
                        />
                    </CardActionArea>
                    </Card>

                    <Card variant="elevation" sx={{ mt: 1.5, p: 1 }}>
                    <LinearProgressWithLabel percentage={percentage_upload_sucursal} label={logo_sucursal.name} hasIcon={false} />
                    </Card>
                </>
                )}
            </Grid>
            </Grid>
        </Grid>

            {/* Fila adicional */}
            <Grid size={{ xs: 12 }}>
                <Grid container spacing={2}>
                
                </Grid>
            </Grid>
            </Grid>

              
          </Form>
        </Card>
      
  </Box>
)
}